// Explicit Battle selection must never silently attach to the racing session.
if (new URLSearchParams(location.search).has("battleSession")) void import("./battle3d");
else void import("./three");
